import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { createScrollReveal } from "../../utils/createScrollReveal";

gsap.registerPlugin(ScrollTrigger);

const EASE = "expo.out";
const TAG_SELECTOR = ".c-lifetime-push__tag";

export default class LifetimePush {
  constructor(el) {
    this.el = el;

    this.setupReveal();
  }

  setupReveal() {
    const title = this.el.querySelector(".c-lifetime-push__title");
    if (!title) return;

    this.reveal = createScrollReveal({
      trigger: this.el,
      // Same as story-push: the tags' appear + shake sequencing matters
      // regardless of scroll speed, so skip the fast-fling bypass.
      velocityThreshold: Infinity,
      build: () => {
        const cta = this.el.querySelector(".newsletter-modal-push-wrapper");

        // Lines are hand-wrapped spans (not SplitText) so the mobile-only
        // <br> keeps working.
        const lines = Array.from(title.querySelectorAll(".c-lifetime-push__line"));
        const tags = Array.from(title.querySelectorAll(TAG_SELECTOR));

        // The markup ships with `is-vibrating`; its CSS animation on
        // `transform` would fight the scale-in tween, so it's held back until
        // the tags have appeared.
        tags.forEach((t) => t.classList.remove("is-vibrating"));
        if (cta) gsap.set(cta, { opacity: 0 });

        const tl = gsap.timeline({ delay: 0.2, paused: true });

        tl.fromTo(
          lines,
          { y: "100%", opacity: 0 },
          { y: "0%", opacity: 1, duration: 0.8, ease: EASE, stagger: 0.2 },
          0
        );

        tl.fromTo(
          tags,
          { scale: 1.2, autoAlpha: 0 },
          { scale: 1, autoAlpha: 1, duration: 0.8, ease: EASE, stagger: 0.3 },
          0.4
        );
        tl.addLabel("tagsAppeared");

        tl.call(
          () => tags.forEach((t) => t.classList.add("is-vibrating")),
          null,
          "tagsAppeared+=1.5"
        );

        if (cta) {
          tl.fromTo(cta, { opacity: 0 }, { opacity: 1, duration: 1.2, ease: EASE }, "tagsAppeared-=0.3");
        }

        return {
          tl,
          teardown: () => {
            gsap.set(lines, { clearProps: "transform,opacity" });
            // GSAP bakes the class's `rotate`/`translate` tilt into its inline
            // transform and sets them to `none` inline; once tag-vibrate
            // overrides that transform the tilt would be lost, so hand the
            // tilt back to the stylesheet.
            gsap.set(tags, { clearProps: "transform,translate,rotate,scale,opacity,visibility" });
            // A fast-scroll snap suppresses tl.call, hence the class is added
            // here too.
            tags.forEach((t) => t.classList.add("is-vibrating"));
            if (cta) gsap.set(cta, { clearProps: "opacity" });
          },
        };
      },
    });
  }

  destroy() {
    this.reveal?.destroy();
  }
}
